import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {HEADER_NAMES, HEADER_VALUES} from '../../api/endpoints/tj-request-headers';
import {catchError, finalize} from 'rxjs/operators';
import {LoaderService} from '../services/loader.service';

@Injectable({
  providedIn: 'root'
})
export class LoaderHttpInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.get(HEADER_NAMES.REQUEST_TYPE) === HEADER_VALUES.REQUEST_TYPE.BACKGROUND) {
      return next.handle(req);
    }

    this.loaderService.show();

    return next.handle(req).pipe(
      finalize(() => this.loaderService.hide()),
      catchError(error => throwError(error))
    );
  }
}
